var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('van-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){$event.stopPropagation();return _vm.goCashier.apply(null, arguments)}}},[_vm._v("立即支付")])
}
var staticRenderFns = []

export { render, staticRenderFns }